import {
  enrutador,
  environment,
  microfrontend,
} from 'src/environments/environment'
import { GOOGLE_MAPS_API_KEY } from 'src/environments/secrets'

interface GoogleMapsConfig {
  apiKey: string
  mapId: string
}

/**
 * Configuración de Google Maps.
 * Fallback: valores de secrets.ts / constants locales.
 * Jenkins puede sobreescribir via config.json por dominio.
 */
export const googleMaps: GoogleMapsConfig = {
  apiKey: GOOGLE_MAPS_API_KEY,
  mapId: 'DEMO_MAP_ID',
}

/**
 * Carga la configuración pública del dominio desde `/config.json`.
 *
 * Delega en el loader compartido de `@his-sinergia/lib-utils` (mezcla
 * profunda por sección, tolerante a 404/HTML/JSON inválido con fallback al
 * build) e incluye el `googleMaps` local como una sección más.
 * Los valores del JSON sobrescriben parcialmente la configuración compilada
 * en `environment` / `enrutador` / `microfrontend` / `googleMaps`.
 *
 * No lanza errores: ante cualquier fallo conserva el fallback compilado
 * (útil para desarrollo local sin `config.json`).
 */
export async function loadRuntimeConfig(): Promise<void> {
  // Lib shared: solo resuelve vía import() después de initFederation()
  const { loadRuntimeConfig: loadSharedRuntimeConfig } =
    await import('@his-sinergia/lib-utils')
  return loadSharedRuntimeConfig({
    targets: { environment, enrutador, microfrontend, googleMaps },
  })
}
